<ng-container *transloco="let t; read: 'partials.agenda.exercise_group'">
  <p *ngIf="container.exercise.settings === null" class="exercise-settings-empty">{{ t('exercise_settings_empty') }}</p>
  <p *ngIf="container.exercise.settings !== null && !isAssigned()" class="exercise-settings-empty">{{ t('not_assigned') }}</p>
  <ng-container *ngIf="isAssigned() && container.exercise">
    <div class="p-grid">
      <ng-container *ngFor="let group of container.exercise.groups">
        <div *ngIf="auth.isModerator() === true || group.isInGroup(auth.getHashedId())" class="p-col">
          <div class="group-container">

            <p class="group-name">{{ group.name }}</p>

            <!-- TEAM -->
            <ng-container *ngIf="container.exercise.isTeam()">

              <ng-container *ngFor="let candidate of group.candidates">
                <app-avatar
                  [user]="candidate"
                  [type]="'candidate'"
                  [mode]="'small'"
                ></app-avatar>
              </ng-container>

              <ng-container *ngFor="let observer of group.observers">
                <app-avatar
                  [user]="observer"
                  [type]="'observer'"
                  [mode]="'small'"
                  [groupModerator]="group.isGroupModerator(observer.hashed_id)"
                ></app-avatar>
              </ng-container>

              <div class="slot-list group">
                <ng-container *ngFor="let slot of container.slots">
                  <app-agenda-exercise-slot
                    [slot]="slot"
                    [group]="group"
                    [container]="container"
                  ></app-agenda-exercise-slot>
                </ng-container>
              </div>

            </ng-container>

            <!-- INDIVIDUAL -->
            <ng-container *ngIf="container.exercise.isIndividual()">

              <ng-container *ngFor="let candidate of group.candidates; index as i">

                <p class="pause" *ngIf="auth.isCandidate() && i === 0 && candidate.hashed_id !== auth.getHashedId()">
                  <i class="pi pi-moon">&nbsp;{{ t('exercise_pause_start') }}</i>
                </p>

                <div class="individual-container" *ngIf="hasPause(group, candidate) === false">

                  <app-avatar
                    [user]="candidate"
                    [type]="'candidate'"
                    [mode]="'small'"
                  ></app-avatar>

                  <ng-container *ngFor="let observer of group.observers">
                    <app-avatar
                      [user]="observer"
                      [type]="'observer'"
                      [mode]="'small'"
                      [groupModerator]="group.isGroupModerator(observer.hashed_id)"
                    ></app-avatar>
                  </ng-container>

                  <div class="slot-list group">
                    <ng-container *ngFor="let slot of container.slots">
                      <app-agenda-exercise-slot
                        [slot]="slot"
                        [candidate]="candidate"
                        [group]="group"
                        [container]="container"
                        [index]="i"
                      ></app-agenda-exercise-slot>
                    </ng-container>
                  </div>

                </div>

                <p class="pause end" *ngIf="auth.isCandidate() && (i === group.candidates.length - 1) && candidate.hashed_id !== auth.getHashedId()">
                  <i class="pi pi-moon">&nbsp;{{ t('exercise_pause_end') }}</i>
                </p>

              </ng-container>

            </ng-container>

          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>



</ng-container>
